import React from 'react'
import { ElementProps } from '../base/element'

import {
  IContainerComponent,
} from '../schemamanager/types'

export interface ITabComponent extends IContainerComponent {
  type: 'tab'
  label: string
  iconComp?: any
}

export const Tab = ({children, mergeStyles, events}: ElementProps) => {
  const m = mergeStyles({main: {classes: {}}})

  return <div {...m.main} {...events()}>{children}</div>
}
